import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  MenuItem,
  Menu,
  IconButton,
  Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';

const UserMenu = ({ handleLogOut }) => {
  const { loginName } = useSelector(state => state.employee);
  const [ anchorEl, setAnchorEl ] = useState(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const useStyles = makeStyles({
    loginNameGridItem: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    loginName: {
      wordBreak: 'break-all'
    }
  });

  const classes = useStyles();

  return (
    <Grid
      item
      container
      xs={ 4 }
      sm={ 7 }
      md={ 7 }
      className={ classes.loginNameGridItem }
      justifyContent="flex-end"
      alignItems="center"
    >
      <div className={ classes.loginName }>
        { loginName }
      </div>
      <IconButton
        aria-label="account-of-current-user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={ handleMenu }
        color="inherit"
        className="user-menu-btn"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={ anchorEl }
        anchorOrigin={ { vertical: 'top', horizontal: 'right' } }
        keepMounted
        transformOrigin={ { vertical: 'top', horizontal: 'right' } }
        open={ open }
        onClose={ handleClose }
      >
        <MenuItem
          component={ Link }
          to="/settings"
        >
          { t('common.header.settings') }
        </MenuItem>
        <MenuItem
          onClick = { handleLogOut }
          component={ Link }
          to="/"
        >
          {t('common.header.logout')}
        </MenuItem>
      </Menu>
    </Grid>
  );
};

export default UserMenu;